import React from 'react';
import {COVER_SRC,COVER_ALT} from '../data/content';

// 3D-Buch-Mockup, Cover-URL zentral in data/content.js änderbar
function BookMockup({eager=false,width='max-w-[300px]'}) {
  return (
    <div className="[perspective:1200px]">
      <div className={`mx-auto w-full ${width} transition-transform duration-500 [transform:rotateY(-14deg)_rotateZ(1deg)] hover:[transform:rotateY(-4deg)]`}>
        <img
          src={COVER_SRC}
          alt={COVER_ALT}
          width="720"
          height="1080"
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          className="h-auto w-full rounded-r-lg rounded-l-sm border-l-4 border-gray-900/20 shadow-[20px_26px_45px_rgba(17,24,39,0.35)]"
        />
      </div>
    </div>
  );
}

export default BookMockup;